import {addBaseUrl} from "@mediaspace/shared/utils";
import {StyledMenuItem, StyledListItemIcon} from "../StyledComponents";
import {useButtonAnalytics} from "@mediaspace/hooks";
import {ButtonClickAnalyticsType} from "@mediaspace/shared/types/ButtonClickAnalyticsType";
import {iconsMap} from "../../actions-item/link-action/icons";
import {KmsTypeActionWithAutoFocus} from "../ActionsItem";

/**
 * actions menu link item
 */
const LinkAction = (props: KmsTypeActionWithAutoFocus) => {

    const {link, attributes, label, analyticsValue} = props;

    const sendButtonAnalytics = useButtonAnalytics();

    const sendAnalytics = () => {
        if (analyticsValue) {
            sendButtonAnalytics(`Actions - ${analyticsValue}`, ButtonClickAnalyticsType.CHOOSE);
        }
    }

    return (
        <StyledMenuItem
            autoFocus={props.autoFocus}
            href={addBaseUrl(link.href)}
            component="a"
            onClick={sendAnalytics}
        >
            <StyledListItemIcon>
                {iconsMap[attributes.class]}
            </StyledListItemIcon>
            {label}
        </StyledMenuItem>
    )
}

export default LinkAction;
